import { headerHeight } from '../../theme';

const styles = () => ({
  pageContainer: {
    height: `calc(100vh - ${headerHeight})`,
    display: 'flex',
    flexDirection: 'column',
  },
});

export default styles;
